import React from 'react';
import { CAREERS } from '../data/content';

export default function CareersMarquee() {
  const list = [...CAREERS.roles, ...CAREERS.roles];
  return (
    <section className="py-24 md:py-32">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{CAREERS.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {CAREERS.title}
            <span className="grad-text-red">{CAREERS.titleAccent}</span>
          </h2>
          <p className="mt-6 text-[17px] text-[color:var(--muted)] leading-relaxed">{CAREERS.intro}</p>
        </div>
      </div>

      <div className="mt-14 space-y-4 overflow-hidden">
        {[0, 1].map((row) => (
          <div key={row} className="flex overflow-hidden">
            <div
              className={`flex gap-4 flex-shrink-0 ${row === 0 ? 'animate-marquee' : 'animate-marquee-slow'}`}
              style={row === 1 ? { animationDirection: 'reverse' } : {}}
            >
              {list.map((role, i) => (
                <div
                  key={`${row}-${i}`}
                  className="flex items-center gap-3 px-6 py-3 rounded-full border border-line bg-white whitespace-nowrap"
                >
                  <span className="font-display text-[20px] text-[color:var(--ink)]">{role}</span>
                  <span className="text-red">✦</span>
                </div>
              ))}
            </div>
            <div
              className={`flex gap-4 flex-shrink-0 ${row === 0 ? 'animate-marquee' : 'animate-marquee-slow'}`}
              style={row === 1 ? { animationDirection: 'reverse' } : {}}
              aria-hidden
            >
              {list.map((role, i) => (
                <div
                  key={`${row}-dup-${i}`}
                  className="flex items-center gap-3 px-6 py-3 rounded-full border border-line bg-white whitespace-nowrap"
                >
                  <span className="font-display text-[20px] text-[color:var(--ink)]">{role}</span>
                  <span className="text-red">✦</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
